import { Nav, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const CheckboxColumnsWrapper = styled.div`
    .col-lg-1 {
        width: 10%;
    }

    .checkbox {
        margin-top: 0px;
        margin-bottom: 0px;
    }
`;

export const NavWrapper = styled(Nav)`
    border-bottom: 1px none;

    // & > li > a {
    //     padding: 5px 7.5px;
    // }
    
    & > li > a:hover {
        background-color: #337ab7;
        color: #ddd;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        background-color: #337ab7;
        color: white;
    }

    & > li.active > a:focus {
        background-color: #337ab7;
        color: white;
    }
`;

export const SwapGridWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    & > thead > tr > th {
        background-color: #063d21;
        color: white;
    }

    & > tbody > tr.highlight > td {
        background-color: #FFFF00;
    }
`;

export const FormWrapper = styled.div`
    form {
        margin-bottom: 10px;
    }

    .rdt {
        display: inline-block;
    }

    label.control-label {
        width: 150px;
        text-align: right;
        padding-right: 10px;
    }
`;